<template>
<v-app>
   <v-app-bar
      app
      color="#1e50aa"
      dark
      clipped-right
      
    >
      <v-btn icon v-if="$router.history.current['path'] ==='/results' || $route.name === 'RegMore'" :to="'/'">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn icon v-if="$route.name === 'RegFinish' || $route.name === 'RegResult'"  :to="'/registration'">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <!-- <v-toolbar-title>AvisHASH</v-toolbar-title> -->
      <v-toolbar-title>
        <img src="@/assets/logo.png" alt="" style="max-width: 200px; justify-content: center; align-items: center; display: flex;">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
  <v-container fluid>
     <v-navigation-drawer
      v-model="drawer"
      app
      clipped 
      
      right
      :width="$vuetify.breakpoint.smAndDown ? '90%' : '30%'"
    >
    <v-card
    class="mx-auto"
    tile
    fill-height
  >
    <v-list disabled>
      <v-subheader>Проверка целостности файла</v-subheader>
      <v-list-item-group color="primary">
        <v-list-item>
          <v-list-item-icon style="margin-right:1rem; margin-bottom:0">
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="white-space: pre-wrap;">Перетащите файл в активное поле.</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line>
          <v-list-item-icon style="margin-right:1rem; margin-bottom:0">
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            
            <v-list-item-title style="white-space: pre-wrap;">Получите результат проверки целостности.</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
      </v-list-item-group>
    </v-list>
  </v-card>
    </v-navigation-drawer>
    <v-content>
      <v-tabs grow v-if="$route.path !== '/results' && $route.name !== 'RegMore' && this.$route.name !== 'RegFinish' && this.$route.name !== 'RegResult'">
        <v-tab to="/registration" grow>Регистрация файла</v-tab>
        <v-tab to="/" grow>Проверка файла</v-tab>
        <v-tab to="/idcheck" grow>Проверка по идентификатору</v-tab>
      </v-tabs>
      <router-view></router-view>
    </v-content>
  </v-container>

  </v-app>
</template>


<script>
export default {
  data() {
    return {
      drawer: !this.$vuetify.breakpoint.smAndDown,
    }
  },
  watch: {
    '$route': {
      handler() {
        if (this.$route.path !== '/results' && this.$route.name !== 'RegFinish' && this.$route.name !== 'RegResult') {
          this.$store.dispatch('setDocid', null)
          this.$store.dispatch('uploadFile', null)
        }
      }
    },
  }
}

//  @errorUploadFile = "errorUploadFile"
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
